/*
 * Theme store — browse + pick from all bundled themes. Designed to scale
 * to dozens of themes via a future server-fed catalog without changing
 * the consumer; today the registry is bundled at build time.
 */

.body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  font-family: var(--token-font-body);
}

.hint {
  margin: 0;
  font-size: 13px;
  color: rgba(28, 38, 32, 0.7);
  line-height: 1.4;
}

.grid {
  display: grid;
  /* Explicit column count (set by the component from theme count) so the
   * fit-content dialog hugs the grid and adapts its width to how many
   * themes there are, instead of a fixed giant box. */
  grid-template-columns: repeat(var(--cols, 1), minmax(240px, 320px));
  justify-content: center;
  gap: 16px;
  padding: 4px 4px 8px;
}

.tile {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px 12px 16px;
  background: rgba(255, 255, 255, 0.62);
  border: 1.5px solid rgba(28, 38, 32, 0.12);
  border-radius: 16px;
  cursor: pointer;
  font-family: inherit;
  text-align: center;
  transition:
    transform 120ms ease,
    border-color 120ms ease,
    background 120ms ease,
    box-shadow 120ms ease;
}

.tile:hover {
  background: rgba(255, 255, 255, 0.92);
  transform: translateY(-1px);
}

.tileActive {
  border-color: var(--token-accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--token-accent) 25%, transparent);
}

.preview {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 10px;
  overflow: hidden;
  background-color: #14241a;
  background-size: cover;
  background-position: center;
  position: relative;
}

.previewMascot {
  position: absolute;
  bottom: 6px;
  left: 50%;
  transform: translateX(-50%);
  /* Fill ~90% of the preview vertically so every mascot reads clearly,
   * with `max-width` + `object-fit: contain` so taller / narrower
   * mascots (e.g. the forest moose) don't blow out horizontally and
   * stay proportional to the others. */
  height: 90%;
  max-width: 95%;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(8, 18, 12, 0.4));
}

/* Per-theme thumbnail nudges: narrow-aspect mascots (e.g. the jungle
 * toucan) read smaller than the square mascots inside the 16:9
 * preview. Scale them up so they fill the tile comparably. The
 * mascot's `data-theme-key` is stamped by MascotImage but the picker
 * uses a plain <img>, so we re-derive it from the src URL instead. */
.previewMascot[src*='/jungle/'] {
  /* translateY after scale = on-screen offset in scaled coords; nudges
   * the bottom-anchored toucan down so it sits more centered in the
   * 16:9 tile after the 1.4× upscale. */
  transform: translateX(-50%) translateY(22px) scale(1.4);
  transform-origin: bottom center;
}

.label {
  font-family: var(--token-font-display);
  font-size: 18px;
  color: var(--token-text-primary);
  margin: 0;
}

.currentNote {
  font-family: var(--token-font-ui);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--token-accent);
  margin: -4px 0 0;
}
